import rightImg from "images/about-hero-right.png";
import readytodrive from "images/readytodrive.png";
import SectionGridFeaturePlaces from "./SectionGridFeaturePlaces";
import SectionHero3 from "components/SectionHero/SectionHero3";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import HomeAboutSection from "containers/PageAbout/HomeAboutSection";
import GoPlacesWith from "components/GoPlacesWith/GoPlacesWith";
import ReadytoDrive from "containers/PageAbout/ReadytoDrive";
import { useEffect } from "react";
import WhyLevel305 from "components/why305/why305";
import bgImage from "images/bg-testimonial.png";
import ContactSection from "components/ContactSection/ContactSection";

function PageHome3() {
  useEffect(() => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
  }, []);
  return (
    <div className="nc-PageHome3 relative overflow-hidden bg-black">
      <div>
        <SectionHero3 />
      </div>
      <div className="container relative py-16 mt-28 md:mt-16 lg:mt-0">
        <SectionGridFeaturePlaces />
      </div>
      <div className="py-16 px-12 bg-[#EDAB17]">
        <HomeAboutSection
          rightImg={rightImg}
          heading="Welcome to JoyRides"
          btnText=""
          subHeading="Welcome to JoyRides, your community-based alternative to traditional car rental companies. Established in 2023, we offer affordable, flexible rentals for both business and leisure trips. With multiple locations in the Bay Area and beyond, we prioritize your safety, enjoyment, and experience every time you get behind the wheel."
        />
      </div>
      <div className="p-12 lg:px-24">
        <div className="py-16">
          {/* <GoPlacesWith /> */}
          <WhyLevel305 />
        </div>
      </div>

      <div
        className="relative py-16 bg-cover bg-center"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <SectionClientSay uniqueClassName="PageAbout_" />
      </div>
      <div className="container py-16">
        <ContactSection />
      </div>
      <div className="bg-[#EDAB17] ">
        <div className="container relative py-16 ">
          <ReadytoDrive
            rightImg={readytodrive}
            heading="Book your ride today!"
            btnText=""
            subHeading="Ready to hit the road? Booking with Joy Ride Rental is fast and simple. Browse our fleet online, choose your vehicle, and reserve it within minutes. For personalized assistance, feel free to contact our team directly."
          />
        </div>
      </div>
    </div>
  );
}

export default PageHome3;
